"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterFeaturesByCategory = void 0;

var _memoize = _interopRequireDefault(require("hs-lodash/memoize"));

var _categoryFeatures = require("ecosystem-marketplace-core/constants/groupTags/categoryFeatures");

var getCategoryFeatureValues = (0, _memoize.default)(function (category) {
  return Object.values(_categoryFeatures.BY_CATEGORY[category] || {});
});

var filterFeaturesByCategory = function filterFeaturesByCategory(features, category) {
  var categoryFeatures = getCategoryFeatureValues(category);
  return features.filter(function (feature) {
    return categoryFeatures.includes(feature);
  });
};

exports.filterFeaturesByCategory = filterFeaturesByCategory;


//////////////////
// WEBPACK FOOTER
// ./js/utils/groupTags.js
// module id = 217
// module chunks = 209 210 211 212 213